"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var HostAppView_1 = require("@twii/core-ui-fabric/lib/component/HostAppView");
var ListingListModel_1 = require("../model/ListingListModel");
var ListingListPage_1 = require("./ListingListPage");
var ListingMenuHelper_1 = require("./ListingMenuHelper");
var ListingNavHelper_1 = require("./ListingNavHelper");
var ListingListApp = /** @class */ (function (_super) {
    __extends(ListingListApp, _super);
    function ListingListApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onSelectItem = function (item) {
            ListingNavHelper_1.pushAndLoad(_this.host, { path: "/ozone/listings/" + item.id });
        };
        _this._onAdd = function () {
            ListingNavHelper_1.pushAndLoad(_this.host, { path: "/ozone/listings/add" });
        };
        _this._onRefresh = function () {
            _this.listings.refresh();
        };
        _this._onOpen = function (listing) {
            _this.host.open({ path: "/ozone/listings/" + listing.id + "/launch", makeActive: true, title: listing.title });
        };
        _this._onLoad = function (listing) {
            _this.host.load({ path: "/ozone/listings/" + listing.id + "/launch", title: listing.title });
        };
        return _this;
    }
    Object.defineProperty(ListingListApp.prototype, "host", {
        get: function () {
            return this.props.match.host;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingListApp.prototype, "userProfile", {
        get: function () {
            return this.props.match.userProfile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingListApp.prototype, "listings", {
        get: function () {
            var listings = this.host.state.listings;
            if (!listings) {
                listings = new ListingListModel_1.ListingListModel();
                this.host.setState({ listings: listings });
            }
            return listings;
        },
        enumerable: true,
        configurable: true
    });
    ListingListApp.prototype.componentWillMount = function () {
        this.host.setTitle("All Listings");
        // we deliberately refresh here
        this.listings.load();
    };
    ListingListApp.prototype.render = function () {
        var items = [];
        var backItem = ListingMenuHelper_1.createBackItem(this.host);
        if (backItem) {
            items.push(backItem);
        }
        items.push({
            key: "add",
            title: "Add a new listing",
            iconProps: {
                iconName: "Add"
            },
            onClick: this._onAdd
        });
        var farItems = [
            {
                key: "refresh",
                title: "Refresh listings",
                iconProps: {
                    iconName: "Refresh"
                },
                onClick: this._onRefresh,
                disabled: this.listings.sync.syncing
            }
        ];
        return (React.createElement(HostAppView_1.HostAppView, { host: this.host, commandBarProps: { items: items, farItems: farItems } },
            React.createElement(ListingListPage_1.ListingListPage, { compact: true, wrapping: true, listings: this.listings, onSelectItem: this._onSelectItem, onLoad: this._onLoad, onOpen: this._onOpen })));
    };
    ListingListApp = __decorate([
        mobx_react_1.observer
    ], ListingListApp);
    return ListingListApp;
}(React.Component));
exports.ListingListApp = ListingListApp;
exports.default = ListingListApp;
